import type { LegalDocumentWords } from "./legal-words.ts";

// The Legal Notice (Impressum) in English: the facts § 5 DDG and § 18(2) MStV ask for, read from
// legal-entity.ts. No online dispute platform: the EU closed it on 20 July 2025 (D705).

export const NOTICE_EN: LegalDocumentWords = {
  title: "Legal Notice",
  summary: "Information about the provider of {product}, under § 5 of the German Digital Services Act (DDG).",
  seoDescription: "The legal details of {company}, the business behind {product}, under German law.",
  sections: [
    {
      id: "provider",
      heading: "Provider",
      body: ["{company}", "{address}", "{product} is a product of {company}."],
    },
    {
      id: "represented",
      heading: "Represented by",
      body: ["{director}, Managing Director"],
    },
    {
      id: "register",
      heading: "Commercial register",
      body: ["Registered at the {court} under {register}."],
    },
    {
      id: "contact",
      heading: "Contact",
      body: ["Email: {contact}"],
    },
    {
      id: "content",
      heading: "Responsible for content",
      body: ["Under § 18(2) MStV: {director}, {address}."],
    },
    {
      id: "disputes",
      heading: "Consumer dispute resolution",
      body: [
        "We are neither obliged nor willing to take part in dispute resolution proceedings before a consumer arbitration board.",
      ],
    },
  ],
};
